<template>
    <div class="social-banner social-banner__youtube rounded-lg">


        <YoutubeReelBannerIcon1 class="social-banner__item"></YoutubeReelBannerIcon1>
        <YoutubeReelBannerIcon2 class="social-banner__item"></YoutubeReelBannerIcon2>

        <div class="w-100 h-100 d-flex flex-column justify-center ga-3 px-4 py-2">
            <div class="text-h5 font-weight-bold">YouTube & Shorts</div>
            <div style="letter-spacing: 0.6px;">
                Post videos on YouTube and YouTube Shorts, include your code, and gain referrals!
            </div>
        </div>


    </div>
</template>



<script setup>

import YoutubeReelBannerIcon1 from '@/icons/YoutubeReelBannerIcon1.vue';
import YoutubeReelBannerIcon2 from '@/icons/YoutubeReelBannerIcon2.vue';

</script>